export const handler = (el, e) => {
  const popup = window.open(
    el.href,
    "",
    "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600",
  );
  popup.opener = null;
  return false;
};
